const DIR_VERTICAL   = 1;
const DIR_HORIZONTAL = 2;

export const PanelDirection = {
  'ROW': 1,
  'COL': 2,
}

export const PanelType = {
  'ROOT'      : 0,
  'PANEL'     : 1,
  'DOCUMENTS' : 2,
  'COMMENTS'  : 3,
  'IMAGE'     : 4,
  'THUMB'     : 5,
  'REVIEW'    : 6,
  'COMPARISON_IMAGE' : 7,
  'COMPARISON_THUMB' : 8,
  'COMPARISON_FIELD' : 9,
  'ANALYTICS_RESULT' : 10,
  'ANALYTICS_IMAGE'  : 11,
  'ANALYTICS_THUMB'  : 12,
}

export class PanelData {
  #id;#type;#items;#size;#open;#direction;#is_locked;
  constructor({id, type=PanelType.PANEL, size=0, open=true, is_locked=false, direction=PanelDirection.ROW, items=[]}) {
    this.#id        = id;
    this.#type      = type;
    this.#size      = size;
    this.#open      = open;
    this.#direction = direction;
    this.#items     = items;
    this.#is_locked = is_locked;
  }

  //-----------------------------
  get id() {
    //-----------------------------
    return this.#id;
  }

  //-----------------------------
  get type() {
    //-----------------------------
    return this.#type;
  }

  //-----------------------------
  get size() {
    //-----------------------------
    return this.#size;
  }

  //-----------------------------
  get is_open() {
    //-----------------------------
    return this.#open;
  }

  //-----------------------------
  get is_locked() {
    //-----------------------------
    return this.#is_locked;
  }

  //-----------------------------
  get direction() {
    //-----------------------------
    return this.#direction;
  }

  //-----------------------------
  get items() {
    //-----------------------------
    return this.#items;
  }

  //-----------------------------
  get row_count() {
    //-----------------------------
    if( this.#direction === PanelDirection.ROW ) {
      return this.#items.length;
    } else {
      return 1;
    }
  }

  //-----------------------------
  get col_count() {
    //-----------------------------
    if( this.#direction === PanelDirection.COL ) {
      return this.#items.length;
    } else {
      return 1;
    }
  }

  //-----------------------------------------------------------------
  info() {
    //-----------------------------------------------------------------
    return {
      id        : this.#id,
      type      : this.#type,
      size      : this.#size,
      open      : this.#open,
      direction : this.#direction,
      items     : this.#items,
      is_locked : this.#is_locked,
    }
  }

  //-----------------------------------------------------------------
  setType( type ) {
    //-----------------------------------------------------------------
    if( !Object.values(PanelType).includes( type ) ) return;
    this.#type = type;
  }

  //-----------------------------------------------------------------
  changeDirection() {
    //-----------------------------------------------------------------
    if( this.#direction === PanelDirection.ROW ) {
      this.#direction = PanelDirection.COL;
    } else {
      this.#direction = PanelDirection.ROW;
    }
  }

  //-----------------------------------------------------------------
  setDirection(direction) {
    //-----------------------------------------------------------------
           if( direction === PanelDirection.ROW ) {
      this.#direction = direction;
    } else if( direction === PanelDirection.COL ) {
      this.#direction = direction;
    }
    // if it doesn't match a defined value then do nothing
  }

  //-----------------------------------------------------------------
  setSize( size=0 ) {
    //-----------------------------------------------------------------
    this.#size = size;
  }
  
  //-----------------------------------------------------------------
  close() {
    //-----------------------------------------------------------------
    this.#open = false;
  }
  
  //-----------------------------------------------------------------
  open() {
    //-----------------------------------------------------------------
    this.#open = true;
  }

  //-----------------------------------------------------------------
  createItem( index, id ) {
    //-----------------------------------------------------------------
    this.#items.splice( index, 0, id );
  }

  //-----------------------------------------------------------------
  removeItem( index ) {
    //-----------------------------------------------------------------
    this.#items.splice( index, 1 );
  }
}



class PanelTypeAlt {
  #items;#sizes;#opens;#direction;
  constructor(direction=DIR_HORIZONTAL) {
    this.#items = [];
    this.#sizes = [];
    this.#opens = [];
    this.#direction = direction;
  }

  //-----------------------------
  get row_count() {
    //-----------------------------
    if( this.#direction === DIR_HORIZONTAL ) {
      return this.#items.length;
    } else {
      return 1;
    }
  }

  //-----------------------------
  get col_count() {
    //-----------------------------
    if( this.#direction === DIR_VERTICAL ) {
      return this.#items.length;
    } else {
      return 1;
    }
  }

  //-----------------------------
  get sizes() {
    //-----------------------------
    const temp = this.#opens.map( (is_open, index) => {
      const value = is_open ? this.#sizes[index]||0 : 0;
      return value;
    } )
            if( this.#direction === DIR_HORIZONTAL ) {
      return { cols: [100] , rows: temp  };
    } else if( this.#direction === DIR_VERTICAL   ) {
      return { cols: temp  , rows: [100] };
    }
  }

  //-----------------------------------------------------------------
  save() {
    //-----------------------------------------------------------------
    
  }

  //-----------------------------------------------------------------
  setDirection(direction) {
    //-----------------------------------------------------------------
    if( direction === DIR_HORIZONTAL ) {
      this.#direction = direction;
    } else if( direction === DIR_HORIZONTAL ) {
      this.#direction = direction;
    }
    // if it doesn't match a defined value then do nothing
  }

  //-----------------------------------------------------------------
  setCellSize( row, col, size=20 ) {
    //-----------------------------------------------------------------
    const index = this.getCellIndex( row, col );
    const temp = this.#opens.map( (is_open, index) => {
      const value = is_open ? this.#sizes[index] : 0;
      return value;
    } )
    return this.#sizes[index] = size;
  }
  
  //-----------------------------------------------------------------
  setSizes( sizes ) {
    //-----------------------------------------------------------------
    const values = sizes.cols.length>1 ? sizes.cols : sizes.rows;
    const temp = this.#opens.map( (is_open, index) => {
      const value = is_open ? values[index] : this.#sizes[index];
      return value;
    } );
    return this.#sizes = temp;
  }
  
  //-----------------------------------------------------------------
  collapseCell( row, col ) {
    //-----------------------------------------------------------------
    const index = this.getCellIndex( row, col );
    this.#opens[index] = false;
  }
  
  //-----------------------------------------------------------------
  openCell( row, col ) {
    //-----------------------------------------------------------------
    const index = this.getCellIndex( row, col );
    this.#opens[index] = true;
  }

  //-----------------------------------------------------------------
  getCell( row, col ) {
    //-----------------------------------------------------------------
    const index = this.getCellIndex( row, col );
    return this.getCellAtIndex( index );
  }
  
  //-----------------------------------------------------------------
  setCell( row, col, data ) {
    //-----------------------------------------------------------------
    const index = this.getCellIndex( row, col );
    this.addCellAtIndex( index, data );
  }

  //-----------------------------------------------------------------
  removeCell( row, col ) {
    //-----------------------------------------------------------------
    const index = this.getCellIndex( row, col );
    this.removeCellAtIndex( index );
  }

  //-----------------------------------------------------------------
  getCellIndex(row, col) {
    //-----------------------------------------------------------------
    if( this.#direction === DIR_HORIZONTAL ) {
      let temp = row;
      row = col;
      col = temp;
    }
    const index = (row * this.#items.length) + col;
    return index;
  }

  //-----------------------------------------------------------------
  getCellAtIndex( index ) {
    //-----------------------------------------------------------------
    return this.#items[index];
  }

  //-----------------------------------------------------------------
  setCellAtIndex( index, data ) {
    //-----------------------------------------------------------------
    this.#items[index] = data;
  }

  //-----------------------------------------------------------------
  addCellAtIndex( index, data ) {
    //-----------------------------------------------------------------
    this.#items.splice( index, 0, data        ) ;
    this.#sizes.splice( index, 0, data.size    ); // add default size
    this.#opens.splice( index, 0, data.is_open||true );
  }

  //-----------------------------------------------------------------
  removeCellAtIndex( index ) {
    //-----------------------------------------------------------------
    this.#items.splice(index, 1);
    this.#sizes.splice(index, 1);
    this.#opens.splice(index, 1);
  }

  //-----------------------------------------------------------------
  moveCell( a, b, is_above ) {
    //-----------------------------------------------------------------
    const cell_a = this.getCell( a.row, a.col );

    const is_new_item = cell_a?.id !== a.id;
    const moved_item_index = is_new_item ? -1 : this.getCellIndex( a.row, a.col );
    const b_index = this.getCellIndex( b.row, b.col );

    const   to_above = is_above;
    const from_above = moved_item_index < b_index;
    const to_above_from_above =  to_above &&  from_above;
    const to_above_from_below =  to_above && !from_above;
    const to_below_from_above = !to_above &&  from_above;
    const to_below_from_below = !to_above && !from_above;

    const direction = to_above_from_above ? 0 : to_above_from_below ? 0 : to_below_from_above ? 1 : to_below_from_below ? 1 : 0;
    const size_a = this.#sizes.splice( moved_item_index, 1 );
    const open_a = this.#opens.splice( moved_item_index, 1 );
    if( !is_new_item ) {
      this.#items.splice( moved_item_index, 1 );
    }
    const new_marked_index = from_above ? b_index-1 : b_index;
    this.#items.splice( new_marked_index + direction, 0 , (is_new_item ?    a : cell_a) );
    this.#sizes.splice( new_marked_index + direction, 0 , (is_new_item ?   10 : size_a) );
    this.#opens.splice( new_marked_index + direction, 0 , (is_new_item ? true : open_a) );
  }
}